import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionsTemplateCategory from 'modules/surveys/store/models/QuestionsTemplateCategory'

class QuestionsTemplateCategories extends Collection<QuestionsTemplateCategory> {
  get cacheKey(): string {
    return 'questionsTemplateCategories'
  }
  model() {
    return QuestionsTemplateCategory
  }
}

const questionsTemplateCategories: QuestionsTemplateCategories = new QuestionsTemplateCategories()

export default questionsTemplateCategories
